import React, { useEffect, useState } from 'react'
import { Modal, Tooltip } from 'antd'
import { Button, FormSubmitButton, FormTextArea, MasterDetailForm } from '@digital/ui'
import { validarSolicitacaoNaoPrevisto } from '@app/api/naoPrevistos/solicitacao';
import { useRecoilState, useRecoilValue } from 'recoil';
import { activeStepHashState, reloadState, solicitacaoIdState, solicitacaoState } from '../atoms';
import * as Yup from 'yup'
import { EStatusSolicitacaoNaoPrevisto, EStepsSolicitacaoNaoPrevisto } from '@app/enums/ENaoPrevisto';
import { Visibility } from '@app/components/Visibility';
import ModalReabrirFinalizarSolicitacao from '../Modals/ModalReabrirFinalizarSolicitacao';
import { hasPermission } from '@app/helpers/permissions';

const ModalReprovarSolicitacao = ({ disabled }: any) => {
    const [reload, setReload] = useRecoilState(reloadState);
    const idSolicitacao = useRecoilValue(solicitacaoIdState);
    const [exibirModal, setExibirModal] = useState(false)
    const [reabrirModal, setReabrirModal] = useState(false)

    const step = useRecoilValue(activeStepHashState);
    const [solicitacao] = useRecoilState(solicitacaoState);

    const title = step === EStepsSolicitacaoNaoPrevisto.ValidacaoAdministrador ||
        step === EStepsSolicitacaoNaoPrevisto.ValidacaoGDGPP ||
        step === EStepsSolicitacaoNaoPrevisto.ValidacaoGerenciaGFG ? 'Não Validar' : 'Reprovar'

    const validationSchema = Yup.object().shape({
        justificativa: Yup.string().required('Campo obrigatório')
    })

    const isReprovado = solicitacao.statusId && (solicitacao.statusId.includes(EStatusSolicitacaoNaoPrevisto.Reprovado) || solicitacao.statusId.includes(EStatusSolicitacaoNaoPrevisto.NaoValidado)) && hasPermission(['NAO_PREVISTO_ADMINISTRADOR']);

    const onValidarSolicitacao = (values: any) => {
        if (idSolicitacao) {
            validarSolicitacaoNaoPrevisto(idSolicitacao, false, values.justificativa).then((result) => {
                setExibirModal(false);
                if (result) {
                    setReload(!reload);
                }
            })
        }
    }

    return (
        <>
            {isReprovado && <Tooltip title="Reabrir">
                <Button
                    id='mrn-button-disapprove'
                    type='success'
                    title="Reabrir"
                    onClick={() => {
                        setReabrirModal(true)
                    }}
                />
            </Tooltip>}

            {!isReprovado && <Tooltip title={title}>
                <Button
                    id='mrn-button-disapprove'
                    type='danger'
                    title={title}
                    onClick={() => {
                        setExibirModal(true)
                    }}
                    disabled={disabled}
                />
            </Tooltip>}

            <Visibility visible={reabrirModal}>
                <ModalReabrirFinalizarSolicitacao
                    justificativa={solicitacao.justificativaReprovacao}
                    responsavel={solicitacao.reprovador}
                    statusId={solicitacao.statusId}
                    statusAprovacaoId={solicitacao.statusAprovacaoId}
                    id={solicitacao.id}
                    exibirModal={reabrirModal}
                    setExibirModal={setReabrirModal}
                />
            </Visibility>

            <Visibility visible={exibirModal}>
                <MasterDetailForm
                    id='mrn-form-modal-disapprove'
                    initialValues={{ justificativa: '' }}
                    onSubmit={onValidarSolicitacao}
                    validationSchema={validationSchema}
                >
                    <Modal
                        className='mrn-modal-step-disapprove'
                        title={`${title} Solicitação`}
                        visible={exibirModal}
                        onCancel={() => setExibirModal(false)}
                        footer={[
                            <Button
                                type='link'
                                title='Fechar'
                                onClick={() => setExibirModal(false)}
                            />,
                            <FormSubmitButton
                                id='mrn-button-stepv2-disapprove'
                                type='danger'
                                title={title}
                                noIcon
                            />
                        ]}
                    >
                        <FormTextArea
                            form='mrn-form-modal-disapprove'
                            name='justificativa'
                            label='Justificativa'
                            rows={6}
                        />
                    </Modal>
                </MasterDetailForm>
            </Visibility>
        </>
    )
}

export default ModalReprovarSolicitacao